import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 'Home',
  // menuItems: [
  //   { id: 1, label: 'Home', path: '/' },
  //   { id: 2, label: 'About Decodia', path: '/about' },
  //   { id: 3, label: 'Services', path: '/services' },
  //   { id: 4, label: 'Process', path: '/process' },
  //   { id: 5, label: 'Pricing Guide', path: '/pricing' },
  //   { id: 6, label: 'Why Decodia', path: '/why' },
  //   { id: 7, label: 'Blog / Design Journal', path: '/blog' },
  //   { id: 8, label: 'Contact Us', path: '/contact' },
  // ],
   menuItems: [
    { id: 1, label: 'Home', path: '/' },
    { id: 2, label: 'About Decodia', path: '/about' },
    { id: 3, label: 'Services', path: '/services' },
    { id: 3, label: 'Blog', path: '/blog' },
    { id: 8, label: 'Contact Us', path: '/contact' },
  ],
  isMenuOpen: false,
  scrollPosition: 0,
};

const navSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    closeMenu: (state) => {
      state.isMenuOpen = false;
    },
    setScrollPosition: (state, action) => {
      state.scrollPosition = action.payload;
    },
    updateMenuItem: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.menuItems.findIndex(item => item.id === id);
      if (index !== -1) {
        state.menuItems[index] = { ...state.menuItems[index], ...updates };
      }
    },
  },
});

export const { 
  setCurrentPage, 
  toggleMenu, 
  closeMenu, 
  setScrollPosition,
  updateMenuItem 
} = navSlice.actions;

export const selectCurrentPage = (state) => state.navigation.currentPage;
export const selectMenuItems = (state) => state.navigation.menuItems;
export const selectIsMenuOpen = (state) => state.navigation.isMenuOpen;

export default navSlice.reducer;